import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { product } from '../../data/product';
import { useStickyCta } from '../../hooks/useStickyCta';
import { PrimaryButton } from './PrimaryButton';
export function MobileStickyCta() {
  const visible = useStickyCta('inicio', 'comprar');
  return <AnimatePresence data-id="element-120" data-mp="3slxb8xsi2hlz">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-sand bg-ivory/95 px-4 pb-[max(env(safe-area-inset-bottom),12px)] pt-3 backdrop-blur md:hidden" data-id="element-121" data-mp="3sk2n7alxm9do">
          <div className="flex items-center justify-between gap-3" data-id="element-122" data-mp="39vfnl7miyc7h">
            <p className="min-w-0 truncate font-serif text-base italic text-carbon" data-id="element-123" data-mp="2m63avxrznm0f">{product.title}</p>
            <PrimaryButton label="Leer el libro" href="#comprar" className="h-12 shrink-0 px-6 text-sm" data-id="element-124" data-mp="2h79y67kizz1b" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}